// Utilitaire pour sauvegarder les logs dans sessionStorage
// Les logs persistent même après la navigation

const MAX_LOGS = 100;

export const debugLog = (message, data = null) => {
  const timestamp = new Date().toISOString();
  const logEntry = {
    timestamp,
    message,
    data: data ? JSON.stringify(data, null, 2) : null
  };
  
  // Log dans la console
  console.log(`[${timestamp}] ${message}`, data || '');
  
  // Sauvegarder dans sessionStorage
  try {
    const existingLogs = JSON.parse(sessionStorage.getItem('debug_logs') || '[]');
    existingLogs.push(logEntry);
    
    // Garder seulement les MAX_LOGS derniers
    if (existingLogs.length > MAX_LOGS) {
      existingLogs.shift();
    }
    
    sessionStorage.setItem('debug_logs', JSON.stringify(existingLogs));
  } catch (e) {
    console.error('Erreur lors de la sauvegarde du log:', e);
  }
};

export const getDebugLogs = () => {
  try {
    return JSON.parse(sessionStorage.getItem('debug_logs') || '[]');
  } catch (e) {
    console.error('Erreur lors de la récupération des logs:', e);
    return [];
  }
};

export const clearDebugLogs = () => {
  sessionStorage.removeItem('debug_logs');
};

// Afficher les logs au chargement de la page
if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    const logs = getDebugLogs();
    if (logs.length > 0) {
      console.log('📋 Logs de débogage précédents:');
      logs.forEach(log => {
        console.log(`[${log.timestamp}] ${log.message}`, log.data ? JSON.parse(log.data) : '');
      });
    }
  });
}

